import * as React from "react";
import type { SVGProps } from "react";
const SvgRecurringbuyIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="recurringbuy_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M725.333 128A42.667 42.667 0 1 0 640 128v42.667H384V128a42.667 42.667 0 0 0-85.333 0v42.667h-85.334a128 128 0 0 0-128 128v512a128 128 0 0 0 128 128h597.334a128 128 0 0 0 128-128v-512a128 128 0 0 0-128-128h-85.334V128zM298.667 298.667a42.667 42.667 0 0 0 85.333 0V256h256v42.667a42.667 42.667 0 1 0 85.333 0V256h85.334a42.667 42.667 0 0 1 42.666 42.667v512a42.667 42.667 0 0 1-42.666 42.666H213.333a42.667 42.667 0 0 1-42.666-42.666v-512A42.667 42.667 0 0 1 213.333 256h85.334v42.667zm448 256a64 64 0 1 0-63.915-60.416L579.584 597.419a65.835 65.835 0 0 0-7.125 0l-82.219-82.176a64 64 0 1 0-127.147 0l-82.218 82.176a64 64 0 1 0 60.33 60.33l85.462-85.376 85.418 85.419a64 64 0 1 0 127.787 0l103.253-103.168 3.542.085z"
    />
  </svg>
);
export default SvgRecurringbuyIcon;
